export const headerKeys = {
  region: 'x-figs-shop-region',
  locale: 'x-figs-shop-locale',
  currency: 'x-figs-shop-currency',
  shopName: 'x-figs-shop-name',
  serviceFilters: 'x-figs-service-filter',
  pageLoadInitialSearchParams: 'x-figs-initial-search-params',
  requestIncludedLocalizationPathParam: 'x-figs-original-request-localized',
} as const
